<template>
    <div class="px-1 pb-1">
        <div class="row" v-if="canEntry">
            <!-- <div class="col-12 text-right">
                <div class="sgk-logo rounded px-1 d-inline-flex align-items-center font-weight-bolder c-pointer" v-on:click="openSGK">
                    <img width="60px" class="mr-50" :src="sgkLogo"/>
                    İşe Giriş İşlemleri
                </div>
            </div> -->
            <div class="col-12 mb-1" v-if="harmful">
                <div class="alert alert-danger mb-0">
                    <div class="alert-body">
                        Bu personelin tekrar işe alımı sakıncalıdır. <template v-if="harmfulReason">{{ harmfulReason }}</template>
                    </div>
                </div>
            </div>
            <!-- <div class="col-12 mb-1">
                <b-form-checkbox v-model="value.SGK">SGK'ya Bildir</b-form-checkbox>
            </div> -->
            <div class="col-12 mb-1">
                <label class="form-label">SGK Şubesi</label>
                <v-validator :errors="errors" parameter="BranchId" :watch="sgkBranch">
                    <v-select-list :options="sgkBranches" label="Name" v-model="sgkBranch" placeholder="SGK Şube"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">SGK Meslek Kodu</label>
                <v-validator :errors="errors" parameter="personeller[0].meslekkodu" :watch="jobCode">
                    <v-select-list v-model="jobCode" :options="jobCodes" label="Combine" v-on:search="searchOT" placeholder="SGK Meslek Kodu" :loading="loadingOT"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 mb-1" v-if="value.SGK">
                <b-form-checkbox v-model="value.ayniIsverenFarkliIsyeriNakil">Aynı İşveren Farklı İşyeri Nakil</b-form-checkbox>
            </div>
            <div class="col-12 mb-1" v-if="value.SGK && value.ayniIsverenFarkliIsyeriNakil">
                <label class="form-label">Nakil Geldiği İşyeri Sicil</label>
                <v-validator :errors="errors" parameter="personeller[0].nakilGeldigiIsyeriSicil" :watch="value.nakilGeldigiIsyeriSicil">
                    <input v-model="value.nakilGeldigiIsyeriSicil" class="form-control" placeholder="Nakil Geldiği İşyeri Sicil" type="text"/>
                </v-validator>
            </div>
            <div class="col-12 mb-1" v-if="value.SGK">
                <label class="form-label">Sigortalı Türü</label>
                <v-validator :errors="errors" parameter="personeller[0].sigortalituru" :watch="insuredType">
                    <v-select-list :options="insuredTypes" v-model="insuredType" placeholder="Sigortalı Türü" label="Value"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 mb-1" v-if="value.SGK">
                <label class="form-label">Görev Kodu</label>
                <v-validator :errors="errors" parameter="personeller[0].gorevkodu" :watch="dutyType">
                    <v-select-list :options="dutyTypes" v-model="dutyType" placeholder="Görev Kodu" label="Value"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 mb-1" v-if="value.SGK">
                <label class="form-label">Çalışma ve Sosyal Güvenlik Bakanlığı İş Kolu</label>
                <v-validator :errors="errors" parameter="personeller[0].personeller[0].csgbiskolu" :watch="businessLine">
                    <v-select-list :options="businessLines" v-model="businessLine" placeholder="Çalışma ve Sosyal Güvenlik Bakanlığı İş Kolu" label="Value"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 mb-1" v-if="value.SGK">
                <b-form-checkbox v-model="value.eskihukumlu">Eski Hükümlü</b-form-checkbox>
            </div>
            <div class="col-12 mb-1" v-if="value.SGK">
                <b-form-checkbox v-model="value.ozurlu" disabled>Engelli</b-form-checkbox>
            </div>
            <div class="col-12 mb-1" v-if="value.SGK">
                <label class="form-label">Öğrenim Kodu</label>
                <v-validator :errors="errors" parameter="personeller[0].ogrenimkodu" :watch="educationCode">
                    <v-select-list :options="educationCodes" v-model="educationCode" placeholder="Öğrenim Kodu" label="Value"></v-select-list>
                </v-validator>
            </div>
            <!-- <div class="col-12 mb-1">
                <label class="form-label">Üniversite</label>
                <v-select-list :options="universities" v-model="university" placeholder="Üniversite" label="Value"></v-select-list>
            </div> -->
            <div class="col-12 mb-1" v-if="value.SGK">
                <label class="form-label">Mezuniyet Bölümü</label>
                <v-validator :errors="errors" parameter="personeller[0].mezuniyetbolumu" :watch="value.mezuniyetbolumu">
                    <input v-model="value.mezuniyetbolumu" class="form-control" placeholder="Mezuniyet Bölümü" type="text"/>
                </v-validator>
            </div>
            <div class="col-12 mb-1" v-if="value.SGK">
                <label class="form-label">Mezuniyet Yılı</label>
                <v-validator :errors="errors" parameter="personeller[0].mezuniyetyili" :watch="value.mezuniyetyili">
                    <v-select-list :options="years" placeholder="Mezuniyet Yılı" v-model="value.mezuniyetyili"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 mb-1" v-if="value.SGK">
                <b-form-checkbox v-model="value.kismiSureliCalisiyormu">Kısmı Süreli Çalışma</b-form-checkbox>
            </div>
            <div class="col-12" v-if="value.SGK && value.kismiSureliCalisiyormu">
                <label class="form-label">Kısmı Süreli Çalışma Gün Sayısı</label>
                <v-validator :errors="errors" parameter="personeller[0].kismiSureliCalismaGunSayisi" :watch="value.kismiSureliCalismaGunSayisi">
                    <input class="form-control" type="number" v-model="value.kismiSureliCalismaGunSayisi" placeholder="Kısmı Süreli Çalışma Gün Sayısı"/>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Tebliğ Tarihi</label>
                <v-validator :errors="errors" parameter="personeller[0].NotifyDate" :watch="value.NotifyDate">
                    <v-date-picker v-model="value.NotifyDate" placeholder="Tebliğ Tarihi"></v-date-picker>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">İşe Giriş Tarihi</label>
                <v-validator :errors="errors" parameter="personeller[0].iseGirisTarihi" :watch="value.iseGirisTarihi">
                    <v-date-picker v-model="value.iseGirisTarihi" placeholder="İşe Giriş Tarihi"></v-date-picker>
                </v-validator>
            </div>
            <div class="col-12 text-right">
                <v-executer :loading="loading" :action="entryNotice" text="İşe Giriş"></v-executer>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <div class="alert alert-warning mb-0">
                    <div class="alert-body text-center p-1">
                        Kullanıcının çalışma bilgisi sistemde kayıtlıdır.<br/>Bu kullanıcının çıkışı yapılmadan girişi yapılamaz.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {BFormCheckbox} from 'bootstrap-vue'
import moment from 'moment'
import EmployeeOperationsApi from '@/api/employee-operations'
import CompanyApi from '@/api/company'
import SystemDataApi from '@/api/system-data'
import VExecuter from '@/components/VExecuter.vue'

export default {
    components:{
        BFormCheckbox,
        VExecuter
    },
    props:{
        value:Object,
        canEntry:Boolean,
        info:Object,
        getPersonal:Function,
        refreshNotices:Function,
        id:[String,Number],
    },
    data(){
        return{
            errors:{},
            sgkBranches:[],
            years:[],
            insuredTypes:[],
            dutyTypes:[],
            businessLines:[],
            educationCodes:[],
            educationDepartments:[],
            universities:[],
            jobCodes:[],
            university:null,
            loading:false,
            loadingOT:false,
            sgkLogo:require('@/assets/images/logo/sgk.svg'),
        }
    },
    mounted(){
        this.configureYears()
        this.getInsuredTypes()
        this.getDutyTypes()
        this.getCSGB()
        this.getEducationCodes()
        this.getBranches()
        this.getUniversities()
    },
    methods:{
        getInsuredTypes(){
            EmployeeOperationsApi.Employee.SGK.Type("sigortalituru").then(res=>{
                this.insuredTypes = res.data.Data
            })
        },
        getDutyTypes(){
            EmployeeOperationsApi.Employee.SGK.Type("gorevkodu").then(res=>{
                this.dutyTypes = res.data.Data
            })
        },
        getCSGB(){
            EmployeeOperationsApi.Employee.SGK.Type("csgbiskolu").then(res=>{
                this.businessLines = res.data.Data
            })
        },
        getEducationCodes(){
            EmployeeOperationsApi.Employee.SGK.Type("ogrenimkodu").then(res=>{
                this.educationCodes = res.data.Data
            })
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sgkBranches = res.data.Data
            })
        },
        getUniversities(){
            SystemDataApi.University().then(res=>{
                this.universities = res.data.Data
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        entryNotice(){
            this.loading = true
            EmployeeOperationsApi.Employee.SGK.EntryNotice({
                ayniIsverenFarkliIsyeriNakil:this.value.ayniIsverenFarkliIsyeriNakil,
                nakilGeldigiIsyeriSicil:this.value.nakilGeldigiIsyeriSicil,
                BranchId:this.value.branchId,
                SGK:this.value.SGK,
                personeller:[{
                    EmployeeId: this.id,
                    OccupationTitleId: this.value.OccupationTitleId || '',
                    sigortalituru: this.value.sigortalituru || '',
                    gorevkodu: this.value.gorevkodu || '',
                    meslekkodu: this.value.meslekkodu || '',
                    csgbiskolu: this.value.csgbiskolu || '',
                    eskihukumlu: this.value.eskihukumlu || false,
                    ozurlu: this.value.ozurlu || false,
                    ogrenimkodu: this.value.ogrenimkodu || '',
                    mezuniyetbolumu: this.value.mezuniyetbolumu || '',
                    kismiSureliCalisiyormu: this.value.kismiSureliCalisiyormu || false,
                    kismiSureliCalismaGunSayisi: this.value.kismiSureliCalismaGunSayisi || 0,
                    mezuniyetyili: this.value.mezuniyetyili || 0,
                    iseGirisTarihi: this.value.iseGirisTarihi || '',
                    NotifyDate: this.value.NotifyDate || ''
                }],
            }).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.getPersonal()
                    this.refreshNotices()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        openSGK(){
            const w = 1366
            const h = 768
            const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
            const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

            const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
            const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

            const systemZoom = width / window.screen.availWidth;
            const left = (width - w) / 2 / systemZoom + dualScreenLeft
            const top = (height - h) / 2 / systemZoom + dualScreenTop
            const view = window.open('https://uyg.sgk.gov.tr/SigortaliTescil/amp/loginldap?isyeri_sifre=11','MsgWindow',`
                scrollbars=yes,
                width=${w / systemZoom}, 
                height=${h / systemZoom}, 
                top=${top}, 
                left=${left}
            `)
        },
        searchOT(search){
            if(search){
                this.loadingOT = true
                SystemDataApi.OccupationTitlePrefix(search)
                .then(res=>{
                    this.jobCodes = res.data.Data?.map(d=>({
                        ...d,
                        Combine:[d.SGKOccupationCode,d.Name].join(' - ')
                    }))
                    this.loadingOT = false
                }).catch(err=>{ 
                    this.loadingOT = false 
                })
            }
        },
    },
    computed:{
        insuredType:{
            get:function(){
                return this.insuredTypes.find(i=>i.Code==this.value.sigortalituru)
            },
            set:function(value){
                this.value.sigortalituru = value?.Code || null
            }
        },
        dutyType:{
            get:function(){
                return this.dutyTypes.find(i=>i.Code==this.value.gorevkodu)
            },
            set:function(value){
                this.value.gorevkodu = value?.Code || null
            }
        },
        businessLine:{
            get:function(){
                return this.businessLines.find(i=>i.Code==this.value.csgbiskolu)
            },
            set:function(value){
                this.value.csgbiskolu = value?.Code || null
            }
        },
        educationCode:{
            get:function(){
                return this.educationCodes.find(i=>i.Code==this.value.ogrenimkodu)
            },
            set:function(value){
                this.value.ogrenimkodu = value?.Code || null
            }
        },
        sgkBranch:{
            get:function(){
                return this.sgkBranches.find(b=>b.Id==this.value.branchId)
            },
            set:function(value){
                this.value.branchId = value?.Id || null
            }
        },
        jobCode:{
            get:function(){
                return this.jobCodes.find(i=>i.Id==this.value.OccupationTitleId)
            },
            set:function(value){
                this.value.OccupationTitleId = value?.Id || null
                this.value.meslekkodu = value?.SGKOccupationCode || null
            }
        },
        harmful(){
            return this.$safe(this.info,'Harmful') || false
        },
        harmfulReason(){
            return this.$safe(this.info,'HarmfulReason') || false
        },

    }
}
</script>

<style>
.sgk-logo{
    background-color: #0087C2;
    color: white;
}
.sgk-logo:hover{
    opacity: 0.95;
}
.sgk-logo:active{
    opacity: 0.85;
}
</style>